module.exports = __webpack_public_path__ + "static/media/塚田卓球場.b084aafb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/exhibition/塚田卓球場.png
// module id = 318
// module chunks = 10